<template>
<div id="point">
  <Vue100vh v-if="!isMobile().any">
    <div class="w-100 h-100 bg-cover d-flex" v-prlx.background="{ speed: 0.07 }" :style="{backgroundImage: 'url('+ bgImage +')'}">
      <div class="w-100 h-100 d-flex px-5 justify-content-center align-items-center">
        <h2 class="display-3 text-white">毎日着たくなるシャツ</h2>
      </div>
    </div>
  </Vue100vh>
  <div v-else class="w-100 py-5 bg-cover d-flex" v-prlx.mobile.background="{ speed: 0.07 }" :style="{backgroundImage: 'url('+ bgImage +')'}">
    <div class="w-100 py-md-5 d-flex px-3 justify-content-center align-items-center">
      <h2 class="h1 text-white my-5">毎日着たくなるシャツ</h2>
    </div>
  </div>


  <div class="py-4">
  </div>

  <b-container class="py-md-5" id="point-2">
    <b-row>
      <b-col cols="12" md="6" class="mb-5 d-md-flex align-items-center justify-content-end">
        <div>
          <h6 class="h2 text-navy overpass tracking-2 text-right pr-lg-5">point<span class="display-4 ml-2">1</span></h6>
          <div class="svg-wrapper ml-auto" style="width: 300px;">
            <div class="balloon-l scroll-reveal-expand">
              左ききにうれしい
            </div>
            <div class="scroll-reveal-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="543" heigth="201" viewBox="0 0 542.42 200.99">
                <defs>
                    <path id="point1-1" stroke="none" fill="none" d="M25.67,71.79c99,8.83,318.42,32.72,495.62,83"/>
                    <path id="point1-2" stroke="none" fill="none" d="M19,136.52c73,6.51,211.4,21.2,350.11,48.62"/>
                </defs>
                <use xlink:href="#point1-1"/>
                <use xlink:href="#point1-2"/>
                <text fill="#133d83" font-family="sans-serif" font-size="35" font-weight="bold">
                  <textPath xlink:href="#point1-1" startOffset="0%">
                    左手でボタンを掛けやすく
                  </textPath>
                </text>
                <text fill="#133d83" font-family="sans-serif" font-size="35" font-weight="bold">
                  <textPath xlink:href="#point1-2" startOffset="0%">
                    “合わせ”を左前に
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="mb-md-5">
        <div class="v-scroll-reveal">
          <img class="img-fluid" src="@/assets/images/point-1.jpg" srcset="@/assets/images/point-1@2x.jpg 2x">
        </div>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col cols="12" md="6" order-sm="2" class="pt-lg-5 mb-5">
        <div>
          <div class="svg-wrapper" style="width: 300px;">
            <div class="balloon-r scroll-reveal-expand">
              左ききにうれしい
            </div>
            <div class="scroll-reveal-up">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489.18 191">
                <defs>
                  <path id="point2-1" stroke="none" fill="none" d="M8.54,123.09c155.37-4.65,341.54-22.31,464.71-74.31"/>
                  <path id="point2-2" stroke="none" fill="none" d="M243.6,171.19c89-11.4,174.5-29.51,241.38-57.75"/>
                </defs>
                <use xlink:href="#point2-1"/>
                <use xlink:href="#point2-2"/>
                <text fill="#133d83" font-family="sans-serif" font-size="35" font-weight="bold">
                  <textPath xlink:href="#point2-1" startOffset="0%">
                    左手で出し入れしやすい
                  </textPath>
                </text>
                <text fill="#133d83" font-family="sans-serif" font-size="35" font-weight="bold">
                  <textPath xlink:href="#point2-2" startOffset="0%">
                    右胸ポケット
                  </textPath>
                </text>
              </svg>
            </div>

          </div>
          <h6 class="scroll-reveal-up h2 text-navy overpass tracking-2">point<span class="display-4 ml-2">2</span></h6>
        </div>
      </b-col>
      <b-col cols="12" md="6" order-sm="1" class="mb-3 mb-md-5">
        <div class="v-scroll-reveal">
          <img class="img-fluid" src="@/assets/images/point-2.jpg" srcset="@/assets/images/point-2@2x.jpg 2x">        
        </div>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col cols="12" md="6" class="mb-md-5">
        <div class=" scroll-reveal-up">
          <div class="svg-wrapper ml-md-auto mr-md-5" style="width: 240px">
            <svg xmlns="http://www.w3.org/2000/svg" width="368" height="180" viewBox="0 0 367.29 179.14">
              <defs>
                <path id="point3-1" stroke="none" fill="none" d="M19.29,57.79C86.73,63.19,208.92,75,335.8,97.08"/>
                <path id="point3-2" stroke="none" fill="none" d="M127.42,134.66c57.88,5.81,130.13,14.36,205.8,26.54"/>
              </defs>
              <use xlink:href="#point3-1"/>
              <use xlink:href="#point3-2"/>
              <text fill="#133d83" font-family="sans-serif" font-size="35" font-weight="bold">
                <textPath xlink:href="#point3-1" startOffset="10%">
                  部屋干し3時間で
                </textPath>
              </text>
              <text fill="#133d83" font-family="sans-serif" font-size="35" font-weight="bold">
                <textPath xlink:href="#point3-2" startOffset="0%">
                  すぐに乾く
                </textPath>
              </text>
            </svg>
          </div>
          <h6 class="h2 text-navy overpass tracking-2 text-right pr-md-5 mt--4 mt-md-0">point<span class="display-4 ml-2">3</span></h6>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="mb-3 mb-md-5">
        <div class="v-scroll-reveal">
          <img class="img-fluid"  src="@/assets/images/point-3.jpg" srcset="@/assets/images/point-3@2x.jpg 2x">
        </div>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col cols="12" md="6" order-sm="2" class="mb-3 mb-md-5">
        <div class="scroll-reveal-up">
          <h6 class="h2 text-navy overpass ml-md-5 mb--4 mb-md-0 tracking-2">point<span class="display-4 ml-2">4</span></h6>
          <div class="svg-wrapper ml-auto ml-md-5" style="width: 240px; height: 130px; margin-top: -30px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="396" height="203" viewBox="0 0 395.19 202.53">
              <defs>
                <path id="point4-1" stroke="none" fill="none" d="M16.46,124.45c131.24-8.55,270.22-28.17,368.83-69.8"/>
                <path id="point4-2" stroke="none" fill="none" d="M93.72,182.52c105.79-10.74,210.35-30,289.13-63.21"/>
              </defs>
                <use xlink:href="#point4-1"/>
                <use xlink:href="#point4-2"/>
                <text fill="#133d83" font-family="sans-serif" font-size="35" font-weight="bold">
                  <textPath xlink:href="#point4-1" startOffset="10%">
                    綿のような風合いで
                  </textPath>
                </text>
                <text fill="#133d83" font-family="sans-serif" font-size="35" font-weight="bold">
                  <textPath xlink:href="#point4-2" startOffset="0%">
                    着心地ばつぐん
                  </textPath>
                </text>
            </svg>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" order-sm="1" class="mb-3 mb-md-5">
        <div class="v-scroll-reveal">
          <img class="img-fluid" src="@/assets/images/point-4.jpg" srcset="@/assets/images/point-4@2x.jpg 2x">
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="6" class="mb-3 mb-md-5 d-md-flex align-items-center justify-content-end">
        <div class="scroll-reveal-up">
          <div class="svg-wrapper ml-md-auto mr-md-5 mb--6 mb-md-0" style="width: 240px; height: 130px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="396" height="203" viewBox="0 0 395.19 202.53">
              <defs>
                <path id="point5-1" stroke="none" fill="none" d="M8.17,44.59S256.73,51.7,479.93,94.87"/>
                <path id="point5-2" stroke="none" fill="none" d="M27.84,108.52c83.59,2,184.07,7.15,280.34,19.2"/>
              </defs>
                <use xlink:href="#point5-1"/>
                <use xlink:href="#point5-2"/>
                <text fill="#133d83" font-family="sans-serif" font-size="30" font-weight="bold">
                  <textPath xlink:href="#point5-1" startOffset="0%">
                    ノーアイロンで着れるから
                  </textPath>
                </text>
                <text fill="#133d83" font-family="sans-serif" font-size="30" font-weight="bold">
                  <textPath xlink:href="#point5-2" startOffset="0%">
                    朝の準備がラク
                  </textPath>
                </text>
            </svg>
          </div>
          <h6 class="h2 text-navy overpass tracking-2 text-right text-md-center" style="margin-top: -30px;">point<span class="display-4 ml-2">5</span></h6>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="mb-5">
        <div class="v-scroll-reveal">
          <img class="img-fluid" src="@/assets/images/point-5.jpg" srcset="@/assets/images/point-5@2x.jpg 2x">        
        </div>
      </b-col>
    </b-row>    
  </b-container>

  <div class="py-4">
  </div>

</div>
</template>

<script>
import bg from '@/assets/images/bg-2.jpg'
import bg2x from '@/assets/images/bg-2@2x.jpg'
import bgXs from '@/assets/images/bg-2@xs.jpg'
import isMobile from 'ismobilejs'
import Vue100vh from 'vue-div-100vh'

export default {
  name: 'Point',
  components: {
    Vue100vh
  },
  data() {
    return {
      isMobile: isMobile
    }
  },
  computed: {
    bgImage() {
      if(isMobile().phone) {
        return bgXs
      } else if (window.innerWidth > 1440) {
        return bg2x
      } else if (window.devicePixelRatio > 1) {
        return bg2x
      } else {
        return bg
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mt--4 {
  margin-top: -2rem;
}
.mb--4 {
  margin-bottom: -2rem;
}
.mb--6 {
  margin-bottom: -4rem;
}
.svg-wrapper {
  position: relative;
  svg {
    width: 100%;
    height: 100%;
  }
  .balloon-l {
    position: absolute;
    background-image: url('~@/assets/images/bg-balloon-l.svg');
    background-size: contain;
    background-repeat: no-repeat;
    width: 180px;
    height: 80px;
    color: #009644;
    text-align: center;
    padding-top: 2rem;
    padding-right: 2rem;
    top: -80px;
    left: -35px;
    @media screen and (min-width: 768px) {
      left: -65px;
    }
    @media screen and (min-width: 0992px) {
      left: -100px;
    }
    transform: rotate(10deg);
  }
  .balloon-r {
    position: absolute;
    background-image: url('~@/assets/images/bg-balloon-r.svg');
    background-size: contain;
    background-repeat: no-repeat;
    width: 200px;
    height: 100px;
    color: #009644;
    text-align: center;
    padding-top: 1.75rem;
    padding-left: 2rem;
    transform: rotate(10deg);
    top: calc(100% + 10px);
    left: calc(100% - 155px);
    @media screen and (min-width: 768px) {
      left: calc(100% - 145px);
      top: calc(100% + 20px);
    }
    @media screen and (min-width: 992px) {
      left: calc(100% - 50px);
      top: 100%;
    }

  }

}
</style>
